import { LineChartComponent } from '../charts/line-chart-component'

export class AFLatestActivity extends LineChartComponent {
 static config = {
  selector: 'afLatestActivity',
  controller: AFLatestActivity,
  bindings: LineChartComponent.config.bindings,
  template: LineChartComponent.config.template,
 }

 setProperties() {
     this.onPointClick = this.lineDateClick
  this.hideLegend = true
  this.multiSource = false
 }
}
